import { Container, ContainerProps, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';

interface HomeContainerProps extends ContainerProps {
  backgroundImageUrl: string;
}

const styles = () => ({
  root: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100%',
    paddingTop: '1rem',
    transition: 'background-image 1s ease-in-out'
  }
});

type StyledProps = WithStyles<typeof styles>;

const $HomeContainer: React.FC<HomeContainerProps & StyledProps> = ({
  children,
  backgroundImageUrl,
  classes,
  ...props
}) => (
  <Container
    {...props}
    className={classes.root}
    style={{
      backgroundImage: `url('${backgroundImageUrl}')`,
      ...props.style
    }}
  >
    {children}
  </Container>
);

export const HomeContainer = withStyles(styles)($HomeContainer);
